const READ_FILE_SOURCE = {
  claims: 1,
  inboxDocs: 2,
  toolbar: 3,
};

const EDUCATION_MATERIAL_FOLDER_ID = -1;

const EDUCATION_MATERIAL_STORE_KEY = 'educationMaterialData';

export {
  EDUCATION_MATERIAL_FOLDER_ID,
  EDUCATION_MATERIAL_STORE_KEY,
  READ_FILE_SOURCE,
};
